
import { MarkHearthArch as HearthMark } from "../components/brand/Marks";
import { useBranding } from "../hooks/useBranding";
import { API } from "../lib/api";
import { householdQuery } from "../lib/household";

// Firm logo + name for advisor-managed vaults; falls back to the HearthVault mark.
export const BrandMark = ({ size = "md" }) => {
  const info = useBranding();
  const b = info?.branding;
  const box = size === "lg" ? "h-16 w-16 rounded-2xl" : "h-9 w-9 rounded-xl";
  if (!b) {
    return size === "lg" ? (
      <div className={`${box} mx-auto bg-primary text-primary-foreground grid place-items-center shadow-lg`}><HearthMark className="h-8 w-8" /></div>
    ) : (
      <>
        <div className={`${box} bg-primary text-primary-foreground grid place-items-center shadow-sm`}><HearthMark className="h-5 w-5" /></div>
        <div className="leading-none hidden sm:block">
          <div className="font-serif text-xl font-semibold tracking-tight">HearthVault</div>
          <div className="text-[9px] uppercase tracking-[0.18em] font-mono text-muted-foreground mt-0.5 hidden min-[2200px]:block" data-testid="brand-tagline">Quietly organized for the moment it matters.</div>
        </div>
      </>
    );
  }
  const logo = b.has_logo ? `${API}/household/logo?${householdQuery()}&v=${encodeURIComponent(b.logo_url.split("v=")[1] || 1)}` : null;
  const Logo = () =>
    logo ? (
      <img src={logo} alt={`${b.firm_name} logo`} data-testid="brand-logo" className={`${box} object-contain bg-white border border-border p-1 ${size === "lg" ? "mx-auto" : ""}`} />
    ) : (
      <div className={`${box} bg-primary text-primary-foreground grid place-items-center font-serif font-semibold ${size === "lg" ? "mx-auto text-2xl" : ""}`} data-testid="brand-initial">
        {(b.firm_name || "A")[0]}
      </div>
    );
  if (size === "lg") {
    return (
      <div data-testid="brand-mark-lg">
        <Logo />
        <div className="mt-3 font-serif text-lg font-medium" data-testid="brand-firm-name">{b.firm_name}</div>
        <div className="text-[10px] uppercase tracking-widest font-mono text-muted-foreground">Powered by HearthVault</div>
      </div>
    );
  }
  return (
    <>
      <Logo />
      <div className="leading-none" data-testid="brand-mark">
        <div className="font-serif text-lg font-semibold tracking-tight truncate max-w-[180px]" data-testid="brand-firm-name">{b.firm_name}</div>
        <div className="text-[10px] uppercase tracking-widest font-mono text-muted-foreground mt-0.5">Powered by HearthVault</div>
      </div>
    </>
  );
};
